<template>
  <div class="authServer">
    <!-- <SearchForm :searchConfig="searchConfig" @callBackAction="callBackAction" /> -->
    <Table
      ref="child"
      :tableConfig="tableConfig"
      :tableData="tableData"
      @callBackAction="callBackAction"
      :api="api"
      :type="type"
      :tableHeight="tableHeight"
    />
    <Drawer
      v-if="showDrawer"
      :showDrawer="showDrawer"
      @changeDrawer="changeDrawer"
      :drawerMode="drawerMode"
      :formData="formData"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      :treeData="treeData"
    />
    <ConnetDrawer
      v-if="showConnectDrawer"
      :showConnectDrawer="showConnectDrawer"
      @changeConnectDrawer="changeConnectDrawer"
      @comfirmConnect="comfirmConnect"
      :selectedItems="selectedItems"
    />
    <Dialog
      :dialogFormVisible="dialogFormVisible"
      @setDialog="setDialog"
      :dialogType="dialogType"
      :dialogTitle="dialogTitle"
      :eventType="eventType"
    />
  </div>
</template>

<script>
// import SearchForm from "@/components/searchForm/index.vue";
import Table from "@/components/table/index.vue";
import Drawer from "./addEditDrawer.vue";
import ConnetDrawer from "./connectResource.vue";
import Dialog from "@/components/dialog/index.vue";
import {
  queryResGroupList,
  addResGroup,
  updateResGroup,
  deleteResGroup,
  relateResGroup,
} from "@/api/authorization.js";

export default {
  components: { Table, Drawer, Dialog, ConnetDrawer },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 250,
      showConnectDrawer: false,
      treeData: [],
      formInline: {},
      selectedItems: [],
      eventType: "",
      dialogTitle: this.$t(`common.alert`),
      dialogType: "yellowType",
      dialogFormVisible: false,
      drawerTitle: "",
      addoreditForm: {},
      formData: [],
      showDrawer: false,
      drawerMode: "add", //edit
      type: "resourceGroup",
      api: {},
      addColumns: [
        {
          prop: "resGroupCode",
          label: this.$t(`authorization.resGroup.resGroupCode`),
          width: "180",
          required: true,
        },
        {
          prop: "resGroupName",
          label: this.$t(`authorization.resGroup.resGroupName`),
          width: "180",
          required: true,
        },
        {
          prop: "resGroupNameCn",
          label: this.$t(`authorization.resGroup.resGroupNameCn`),
          width: "180",
          required: false,
        },
        {
          prop: "belongSys",
          label: this.$t(`authorization.resGroup.belongSys`),
          width: "250",
          required: true,
        },
        {
          prop: "org",
          label: this.$t(`authorization.resGroup.belongOrg`),
          width: "180",
          required: true,
        },
        {
          prop: "effectiveDate",
          label: this.$t(`authorization.resGroup.effectiveDate`),
          width: "180",
          required: true,
        },
        {
          prop: "expDate",
          label: this.$t(`authorization.resGroup.expDate`),
          width: "180",
          required: true,
        },
        {
          prop: "status",
          label: this.$t(`common.status`),
          width: "180",
          required: true,
          placeholder: this.$t(`common.pleaseSelect`),
        },
      ],
      tableData: {},
      searchConfig: {},
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            {
              type: "query",
              name: "common.query",
              event: "query",
              auth: "role_query",
            },
            { type: "add", name: "common.add", event: "add", auth: "role_add" },
            {
              type: "edit",
              name: "common.edit",
              event: "edit",
              auth: "role_edit",
            },
            {
              type: "remove",
              name: "common.remove",
              event: "remove",
              auth: "role_delete",
            },
            {
              type: "connectResource",
              name: "common.connectResource",
              event: "connectResource",
              auth: "role_relResource",
            },
            // { type: "export", name: "导出人员", event: "export" },
          ],
        },
        table: {
          selection: true,
          columns: [
            {
              prop: "resGroupCode",
              label: `authorization.resGroup.resGroupCode`,
              width: "",
            },
            { prop: "resGroupName", label: `common.name`, width: "180" },
            {
              prop: "belongSys",
              label: `authorization.resGroup.belongSys`,
              width: "",
            },
            {
              prop: "org",
              label: `authorization.resGroup.belongOrg`,
              width: "",
            },
            { prop: "status", label: `common.status`, width: "" },
          ],
          action: {},
        },
      },
    };
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    comfirmConnect(arr) {
      let newArr = [];
      arr.forEach((item) => {
        newArr.push(item.details.resCode);
      });
      let data = {
        resGroupCode: this.selectedItems[0].resGroupCode,
        rootOrgCode: this.selectedItems[0].org,
        resCodes: newArr,
      };
      //请求关联接口
      relateResGroup(data).then((res) => {
        if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.changeConnectDrawer(false);
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
      });
    },
    changeConnectDrawer(v) {
      this.showConnectDrawer = v;
    },
    setDialog(v, addOrgForm) {
      if (v) {
        //是编辑保存
        if (this.dialogType == "normalType") {
          updateResGroup(this.addOrgForm).then((res) => {
            if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.showDrawer = false;
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
          });
        } else {
          //是确认删除
          this.confirmDelete();
        }
      }
      this.dialogFormVisible = false;
    },
    confirmDelete() {
      let ids = [];
      this.selectedItems.forEach((item) => {
        ids.push(item.id);
      });
      deleteResGroup({ ids: ids }).then((res) => {
        if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.query();
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
      });
    },
    deleteItem() {
      //需要弹框二次确认
      this.dialogFormVisible = true;
      this.dialogType = "yellowType";
    },
    changeDrawer(v) {
      this.showDrawer = v;
    },
    addoredit(obj) {
      console.log("obj", obj);
      let data = obj.form;
      this.addOrgForm=data
      //去做保存
      if (this.drawerMode == "add") {
        addResGroup(data).then((res) => {
          if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.changeDrawer(false)
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
          console.log(res);
        });
      } else {
        //编辑需要二次弹框
        this.dialogFormVisible = true;
        this.eventType = "confirmEdit";
        this.dialogType = "normalType";
      }
    },
    callBackAction(param) {
      this.selectedItems = param.selectedItems;
      this.formInline = param.formInline;
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    query() {
      let data = {
        currentPage: this.formInline.currentPage || 1,
        pageSize: this.formInline.pageSize || 10,
        condition: {
          vagueParam: this.formInline.inputKey || "",
        },
      };
      queryResGroupList(data).then((res) => {
        this.tableData = res.data;
        this.$nextTick(()=>{
          this.$refs.child.$refs.multipleTable.clearSelection();
        })
      });
    },
    add() {
      this.addoreditForm = {};
      this.changeDrawer(true);
      this.drawerMode = "add";
      this.drawerTitle = this.$t(`authorization.resGroup.addResGroup`);
      this.formData = this.addColumns;
    },
    edit() {
      if (this.selectedItems.length > 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      this.changeDrawer(true);
      this.drawerMode = "edit";
      this.drawerTitle = this.$t(`authorization.resGroup.editResGroup`);
      // this.formData = this.tableConfig.table.columns;
      this.formData = this.addColumns;
      this.addoreditForm = this.selectedItems[0];
    },
    remove() {
      this.deleteItem();
    },
    connectResource() {
      if (this.selectedItems.length > 1||this.selectedItems.length == 0) {
        this.$message({
          message: this.$t(`authorization.resGroup.onlyConnect`),
          type: "info",
        });
        return;
      }
      this.changeConnectDrawer(true);
      // this.getTreeData();
    },
    export() {},
  },
};
</script>
<style lang="less" scoped></style>
